import request from '@/utils/request';
import { emallApi } from '@/utils/util';

export function assemblyParameters(data) {
  return request({
    url: `${emallApi}/payment/assemblyParameters`,
    method: 'post',
    data
  });
}
export function payment4WapAlipay(data) {
  return request({
    url: `${emallApi}/payment/payment4WapAlipay`,
    method: 'post',
    data
  });
}
